import Component from "./ShortcutChip";
export default Component;
